import { UIBModalService, UIBModalServiceOptions } from '@b2b/types/core';
import angular from 'angular';

export class ModalService {
  static $inject = ['$uibModal'];

  constructor(private $uibModal: UIBModalService) {}

  open<T>(options: UIBModalServiceOptions) {
    return this.$uibModal.open<T>(options);
  }

  confirm(props: { title: string; message: string; okText?: string; hideOkText?: boolean; cancelText?: string }) {
    return this.$uibModal
      .open({
        templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
        size: 'md',
        controller: 'ConfirmCustomModalController',
        resolve: {
          modalTitle: () => props.title,
          modalMessage: () => props.message,
          okText: () => props.okText ?? 'Done',
          cancelText: () => props.cancelText ?? 'Cancel',
          hideOkText: () => !!props.hideOkText,
        },
      })
      .result.then(() => true)
      .catch(() => false);
  }
}

export const ModalServiceModule = angular
  .module('acme.common.service.modal', ['ui.bootstrap', 'acme.view.application.modals.confirmCustom.controllers'])
  .service('ModalService', ModalService).name;
